module.exports = __webpack_public_path__ + "80162f079d12b7968e5452ace00c107f.svg";